import React from "react";
import { Handle } from 'react-flow-renderer';
import { handlesColors } from "./";

export const HandleOutputGreen = ({isConnectable = true, onConnect, top = "0px", bottom = "unset", height = "50%", borderRadius = "0px 5px 0px 0px"}) => {
  return (
    <Handle
      type="source"
      position="right"
      id="V"
      style={{  backgroundColor: handlesColors.V, transform: "translateY(0%)", top, bottom, borderRadius, height, border: "0px solid white", width: "10px", right: "-10px"  }}
      isConnectable={isConnectable}
      onConnect={onConnect}
    />
  );
}
